import { graphql } from 'gatsby';
import {
  StyledSubheadline,
  StyledImage,
  StyledHeadingWrapper,
  StyledLinksWrapper,
} from './ColumnSection.styles';
import ColumnSectionLink from './ColumnSectionLink';

const SECTION_IMAGE_WIDTH = 272;
const SECTION_IMAGE_HEIGHT = 142;

const ColumnSection = ({ elements }: Queries.HEADER_MENU_ITEM_COLUMN_SECTIONFragment) => {
  const { subheadline, links, image } = elements;
  const imageValue = image?.value && {
    ...image.value,
    description: image.value.description || undefined,
    width: image.value.width ?? SECTION_IMAGE_WIDTH,
    height: image.value.height ?? SECTION_IMAGE_HEIGHT,
  };

  return (
    <div>
      <StyledHeadingWrapper>
        {subheadline?.value && <StyledSubheadline>{subheadline.value}</StyledSubheadline>}
        {imageValue && (
          <StyledImage
            image={{
              ...imageValue,
              image_id: imageValue.url,
            }}
            width={imageValue.width}
            height={imageValue.height}
            alt={imageValue.description}
            layout="fullWidth"
          />
        )}
      </StyledHeadingWrapper>
      <StyledLinksWrapper>
        {links.value.map((link) => (
          <ColumnSectionLink {...link} key={link.system.id} />
        ))}
      </StyledLinksWrapper>
    </div>
  );
};

export default ColumnSection;

export const fragment = graphql`
  fragment HEADER_MENU_ITEM_COLUMN_SECTION on kontent_item_header_menu_item_column_section {
    __typename
    system {
      id
    }
    elements {
      subheadline {
        value
      }
      links {
        value {
          ...HEADER_COLUMN_SECTION_LINK
        }
      }
      image {
        value {
          description
          url
          width
          height
        }
      }
    }
  }
`;
